import type { SkillTagItem } from '../SkillTagRow';

export function buildSkillTags(
  personalizationTags: SkillTagItem[] | null | undefined,
  lastMinuteRequestTag: string | null | undefined
): SkillTagItem[] {
  const result: SkillTagItem[] = [];

  if (lastMinuteRequestTag) {
    result.push({ id: 'last-minute-request', label: lastMinuteRequestTag });
  }

  if (personalizationTags) {
    result.push(...personalizationTags);
  }

  return result;
}
